// Токен в localStorage. Если хранилище недоступно (приватный режим, запрет cookies),
// токен живёт в памяти до перезагрузки страницы.

const KEY = 'cf2_token'
let memory: string | null = null

export function getToken(): string | null {
  try {
    return localStorage.getItem(KEY) ?? memory
  } catch {
    return memory
  }
}

export function setToken(token: string): void {
  memory = token
  try {
    localStorage.setItem(KEY, token)
  } catch {
    // остаётся в памяти
  }
}

export function clearToken(): void {
  memory = null
  try {
    localStorage.removeItem(KEY)
  } catch {
    // нечего чистить
  }
}
